import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaGlobe, FaArrowLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import ContactForm from '../components/ContactForm'; // Imported

const DeveloperPage = () => {
    // Animation Variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
                delayChildren: 0.1
            }
        }
    };

    const leftSlideVariants = {
        hidden: { opacity: 0, x: -50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { type: "spring", stiffness: 100, damping: 15 }
        }
    };

    const rightSlideVariants = {
        hidden: { opacity: 0, x: 50 },
        visible: {
            opacity: 1,
            x: 0,
            transition: { type: "spring", stiffness: 100, damping: 15, delay: 0.2 }
        }
    };

    const bottomSlideVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { type: "spring", stiffness: 80, damping: 15, delay: 0.4 }
        }
    };

    return (
        <div className="developer-page">
            <div className="container" style={{ minHeight: '100vh', paddingTop: '4rem', paddingBottom: '4rem' }}>

                {/* Back Link */}
                <div className="pomodoro-nav" style={{ marginBottom: '3rem' }}>
                    <Link to="/" className="back-link">
                        <FaArrowLeft /> Ana Sayfaya Dön
                    </Link>
                </div>

                <motion.div
                    className="developer-content"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    {/* Hero Section (Text Left, Image Right) */}
                    <div className="developer-hero">
                        {/* Text Column */}
                        <motion.div className="developer-text" variants={leftSlideVariants}>
                            <h1 className="hero-name">Mehmet Değirmenci</h1>
                            <h2 className="developer-job-title">Yazılım Geliştirici & Öğrenci</h2>

                            <div className="hero-bio">
                                <p>
                                    Merhaba! Ben Mehmet. Soruly uygulamasını geliştiren kişiyim.
                                    Öğrencilerin sınav hazırlık süreçlerini kolaylaştırmak ve verimliliklerini artırmak
                                    amacıyla bu projeyi hayata geçirdim. Bilgisayar Mühendisliği 3.sınıf öğrencisiyim. Yapay zeka, modern web teknolojileri ve mobil uygulama
                                    geliştirme üzerine çalışmalar yapıyorum.
                                </p>
                            </div>

                            <div className="social-links-container" style={{ justifyContent: 'flex-start', marginTop: '2rem' }}>
                                <a href="https://github.com/degirmencimehmet" target="_blank" rel="noopener noreferrer" className="social-btn github">
                                    <FaGithub /> <span>GitHub</span>
                                </a>
                                <a href="https://www.linkedin.com/in/degirmencimehmet" target="_blank" rel="noopener noreferrer" className="social-btn linkedin">
                                    <FaLinkedin /> <span>LinkedIn</span>
                                </a>
                                <a href="https://getsoruly.com" target="_blank" rel="noopener noreferrer" className="social-btn website">
                                    <FaGlobe /> <span>Website</span>
                                </a>
                            </div>
                        </motion.div>

                        {/* Image Column */}
                        <motion.div className="developer-image" variants={rightSlideVariants}>
                            <div className="hero-image-wrapper">
                                <img
                                    src="/images/profile.jpeg"
                                    alt="Mehmet Değirmenci"
                                    className="hero-profile-image"
                                />
                            </div>
                        </motion.div>
                    </div>

                    {/* LinkedIn Section (Full Width Bottom) */}
                    <motion.div className="linkedin-section-full" variants={bottomSlideVariants}>
                        <h3 className="section-title-small" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>LinkedIn Profilim</h3>
                        <div className="browser-mockup">
                            <div className="browser-header">
                                <div className="browser-dots">
                                    <span className="dot red"></span>
                                    <span className="dot yellow"></span>
                                    <span className="dot green"></span>
                                </div>
                            </div>
                            <div className="browser-content">
                                <img
                                    src="/images/linkedin-card.jpeg"
                                    alt="LinkedIn Profil Önizleme"
                                    className="linkedin-preview-img"
                                    style={{ objectFit: 'cover', maxHeight: '400px', width: '100%', backgroundColor: '#f3f4f6' }}
                                />
                            </div>
                            <div className="browser-footer" style={{ display: 'flex', justifyContent: 'center' }}>
                                <a href="https://www.linkedin.com/in/degirmencimehmet" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
                                    Profili Ziyaret Et <FaArrowLeft style={{ transform: 'rotate(135deg)', marginLeft: '0.5rem' }} />
                                </a>
                            </div>
                        </div>
                    </motion.div>

                    {/* Contact Section (Split View) */}
                    <div className="developer-hero" style={{ marginTop: '5rem', marginBottom: '0' }}>
                        {/* Text Column */}
                        <motion.div className="developer-text" variants={leftSlideVariants}>
                            <h2 className="hero-name" style={{ fontSize: '2.5rem' }}>Benimle İletişime Geçin</h2>
                            <div className="hero-bio">
                                <p>
                                    Projeleriniz, iş birlikleri veya sadece merhaba demek için bana ulaşabilirsiniz.
                                    Aşağıdaki formu doldurarak bana doğrudan e-posta gönderebilirsiniz.
                                    En kısa sürede dönüş yapmaya çalışacağım.
                                </p>
                            </div>
                        </motion.div>

                        {/* Form Column */}
                        <motion.div className="developer-image" variants={rightSlideVariants} style={{ justifyContent: 'center' }}>
                            <div style={{ width: '100%' }}>
                                <ContactForm />
                            </div>
                        </motion.div>
                    </div>

                </motion.div>
            </div>
            <Footer />
        </div>
    );
};

export default DeveloperPage;
